import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Title = styled(Headline)`
  padding: 1.5rem;
`;

const Info = styled(Headline)`
  padding: 1.5rem 0 4rem 1.5rem;

  border-top: 0.1rem solid ${pickColor('borderSemiLight')};
  border-bottom: 0.1rem solid ${pickColor('borderSemiLight')};
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 2rem;

  padding: 1.5rem;
`;

export { Info, Title, Actions };
